import React, { useMemo, useState } from 'react';
import type { NextPage } from 'next';

import { Modal, Table } from '@douyinfe/semi-ui';
import { useRouter } from 'next/router';

interface IProps {
  visible: boolean,
  onOk?: () => void
}

const MyModal: NextPage<IProps> = ({ visible, onOk }) => {
  const router = useRouter()

  return (
    <div>
      <Modal
        visible={visible}
        // onOk={onOk as any}
        onCancel={onOk}
        centered
        hasCancel={true}
        // closable={false}
        bodyStyle={{ overflow: 'auto' }}
      >
        <img src="https://img.cbcechina.com/2024-12-10/55680c07f06418fb99396fbc289442e3.png" alt="" />
      </Modal>
      <style jsx global>
        {
          `
            .semi-form-field-label-text,
            .semi-input-number-size-default{
              display: flex;
              flex-direction: row-reverse;
              justify-content: left;
              line-height:40px;
            }
            .semi-input-wrapper{
              background:white !important;
              border:none;
            }
            .semi-modal-footer{
              text-align:center;
              margin: 0 0 24px;
            }
            .semi-modal-footer .semi-button{
              display:none;
            }
            .semi-modal-close{
              position: absolute;
              top: 93%;
              color: white !important;
              right: 50%;
              background-color: rgb(255, 255, 255, 0.4) !important;
              border-radius: 50%;
            }
            .semi-modal-content{
              background-color:transparent !important;
              border:none !important;
              box-shadow:none !important;
            }
            .semi-modal-small{
              width:348px;
            }
            @media screen and (min-width: 1000px) {
              .semi-modal-small{
                transform:scale(1.3);
              }
              
            }
          `
        }
      </style>
    </div>
  );
};

export default MyModal;
